import { combineEpics } from "redux-observable"
import { fetchEpic, sendByEmailEpic } from "./epics"

export const proposalEpics = combineEpics(
    fetchEpic,
    sendByEmailEpic,
)



// WEBPACK FOOTER //
// ./src/state/proposal/epics/index.ts